<template>
  <div class="mallManagement">
    <div class="main">
      <div class="side-con">
        <ul>
          <li
            :class="nowIdx == index ? 'active' : ''"
            v-for="(item, index) in newData"
            :key="item.path"
            @click="setChildData(item.children, index)"
          >
            <router-link :to="item.path" class="">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <transition name="el-fade-in-linear">
        <div class="side-left" v-if="child_status">
          <ul class="side-left-con">
            <!-- <router-link
              v-for="(child, index) in childData"
              :key="index"
              :to="child.path"
            >
              <li
                @click="setChild(index)"
                :class="setChildIdx == index ? 'active' : ''"
              >
                <span>{{ child.name }}</span>
                <i v-if="setChildIdx == index" class="el-icon-caret-right"></i>
              </li>
            </router-link> -->
            <div v-for="(child, index) in childData" :key="index" class="son">
              <div
                class="li"
                v-if="!child.children"
                @click="setChild(child.name, child.path)"
                :class="
                  setChildIdx == child.name
                    ? 'active marginTop20'
                    : 'father marginTop20'
                "
              >
                <span>{{ child.name }}</span>
                <i
                  v-if="setChildIdx == child.name"
                  class="el-icon-caret-right"
                ></i>
              </div>
              <div class="li2" v-else>
                <span>{{ child.name }}</span>
              </div>
              <div
                class="li"
                v-for="(son, sonIndex) in child.children"
                :key="sonIndex"
                @click="setChild(son.name, son.path)"
                :class="setChildIdx == son.name ? 'active' : ''"
              >
                <span>{{ son.name }}</span>
                <i
                  v-if="setChildIdx == son.name"
                  class="el-icon-caret-right"
                ></i>
              </div>
            </div>
          </ul>
        </div>
        <div v-else></div>
      </transition>

      <div class="rgt-con" :class="{ 'rgt-con-2': !child_status }">
        <transition name="el-fade-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { initSideBar } from "./initConfig";
export default {
  inject: ["reload"],
  name: "merchants",
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  watch: {
    classid: function(val) {
      console.log("我变换classID", val);
    }
  },
  data() {
    return {
      isCollapse: false,
      classid: this.$route.params.id, //分类
      newData: [],
      childData: [],
      nowIdx: "",
      setChildIdx: "",
      child_status: false,
      initSideBar: initSideBar // 导航数据
    };
  },
  created() {
    if (sessionStorage.getItem("routerIdx")) {
      this.nowIdx = sessionStorage.getItem("routerIdx");
      this.setChildIdx = sessionStorage.getItem("mychild");
      if (sessionStorage.getItem("childRouter")) {
        this.child_status = true;
        this.childData = JSON.parse(sessionStorage.getItem("childRouter"));
      }
    }
    switch (parseInt(this.classid)) {
      case 4:
        this.newData = this.initSideBar.groupData;
        break;
      case 12:
        this.newData = this.initSideBar.merchantsData;
        break;
      case 14:
        this.newData = this.initSideBar.integralMalls;
        break;
      case 7:
        this.newData = this.initSideBar.signData;
        break;
      case 9:
        this.newData = this.initSideBar.couponData;
        break;
      case 10:
        this.newData = this.initSideBar.distributorSetData;
        break;
      case 13:
        this.newData = this.initSideBar.vipData;
        break;
      case 15:
        this.newData = this.initSideBar.storeManage;
        break;
      case 16:
        this.newData = this.initSideBar.employee;
        break;
      case 17:
        this.newData = this.initSideBar.pointSetting;
        break;
      case 18:
        this.newData = this.initSideBar.forumData;
        break;
      case 19:
        this.newData = this.initSideBar.couponSetting;
        break;
      case 20:
        this.newData = this.initSideBar.fullReductionData;
        break;
      case 21:
        this.newData = this.initSideBar.fullPackageData;
        break;
      case 22:
        this.newData = this.initSideBar.luckyDrawData;
        break;
    }
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
    // 侧边栏子数据
    setChildData(data, idx) {
      this.nowIdx = idx;
      sessionStorage.setItem("routerIdx", idx);
      if (data.length > 0) {
        this.child_status = true;
        this.childData = data;
        sessionStorage.setItem("childRouter", JSON.stringify(data));
      } else {
        sessionStorage.setItem("childRouter", "");
        this.childData = [];
        this.child_status = false;
      }
      this.reload();
    },
    setChild(index, path) {
      this.setChildIdx = index;
      sessionStorage.setItem("mychild", index);
      this.$router.push(path);
    }
  }
};
</script>
<style lang="scss" scoped>
.father {
  font-weight: 550;
}
.marginTop20 {
  margin-top: 10px;
}
.son {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(50, 50, 50, 0.1);
}
.mallManagement {
  height: 100%;
  position: relative;
  overflow-y: hidden;
  i {
    color: #000;
  }
  .main {
    width: 100%;
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    overflow: hidden;
    .side-con {
      min-width: 7%;
      background: #22242f;
      overflow: hidden;
      overflow-y: auto;
      padding-top: 30px;
      padding-bottom: 60px;
      ul > li {
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        i {
          color: #757993;
          margin-right: 5px;
        }
        a {
          width: 100%;
          display: block;
          color: #757993;
          font-weight: 400;
          box-sizing: border-box;
        }
        a:hover:after {
          content: "";
          width: 4px;
          background: #fff;
          border-radius: 2px;
          position: absolute;
          right: 10px;
          top: 25%;
          bottom: 25%;
        }
      }
      li.active a,
      li.active i {
        color: #fff;
      }
      li.active a:after {
        content: "";
        width: 4px;
        background: #fff;
        border-radius: 2px;
        position: absolute;
        right: 10px;
        top: 25%;
        bottom: 25%;
      }
    }
    .side-left {
      min-width: 132px;
      height: 100vh;
      background: #fafafa;
      .side-left-con {
        width: 100%;
        display: flex;
        padding: 20px 20px;
        flex-direction: column;
        div {
          width: 100%;
          .li {
            width: 100%;
            height: 42px;
            cursor: pointer;
            text-align: center;
            position: relative;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            //padding: 0 10px;
            justify-content: space-between;
          }
          .li:hover {
            color: #ffa41b;
            opacity: 1;
            background: #ededed;
          }
          .li.active {
            color: #35323b;
            background: #e9eaf0;
            border-radius: 6px;
          }
          .li2 {
            width: 100%;
            height: 42px;
            text-align: center;
            position: relative;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            padding: 0 10px;
            justify-content: space-between;
            font-weight: 550 !important;
          }
        }
      }
    }
    .rgt-con {
      min-width: calc(100% - 230px);
      position: relative;
      flex: 1;
    }
    .rgt-con-2 {
      width: calc(100% - 130px);
    }
  }
}
</style>

<style lang="scss">
.mallManagement {
  .el-menu-item-group__name {
    padding: 0;
  }
}
</style>
